// i18n stub — export default compatible avec i18next interface minimale
const i18n = {
  language: 'en',
  t: (key: string, fallback?: string) => fallback ?? key,
};

export default i18n;
